import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 1.4 6.05 a 4.6 4.6 0 0 1 4.6 -4.6 h 12 A 4.6 4.6 0 0 1 22.6 6.05 v 12 a 4.6 4.6 0 0 1 -4.6 4.6 h -12 A 4.6 4.6 0 0 1 1.4 18.05 V 6.05 Z m 4.6 -2.6 A 2.6 2.6 0 0 0 3.4 6.05 v 12 a 2.6 2.6 0 0 0 2.6 2.6 h 12 a 2.6 2.6 0 0 0 2.6 -2.6 V 6.05 a 2.6 2.6 0 0 0 -2.6 -2.6 h -12 Z"
  />,
  'Square'
)
